import { useMutation, useQueryClient } from "@tanstack/react-query";
import axios from "axios";
import { Customer } from "@/api.types";
import { useSession } from "@/services/auth0/session";

interface ProfileUpdateData {
  firstName: string;
  lastName: string;
  phone?: string;
}

interface UpdateProfileOptions {
  onSuccess?: (data: Customer) => void;
  onError?: (error: any) => void;
}

export const useUpdateProfile = (options?: UpdateProfileOptions) => {
  const { token, user, customer } = useSession();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (data: ProfileUpdateData) => {
      if (!user?.id) throw new Error("No user ID found");

      const response = await axios.patch<Customer>(
        `${import.meta.env.VITE_API_URL}/api/v1/users/${user.id}/profile`,
        data,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      return response.data;
    },
    onSuccess: async (data) => {
      await queryClient.invalidateQueries({
        queryKey: ["customer", customer?.id],
      });
      options?.onSuccess?.(data);
    },
    onError: (error) => {
      options?.onError?.(error);
    },
  });
};
